import * as Sentry from '@sentry/react';

import {
  FETCH_CHECKOUT_DELIVERY_WINDOWS_ERROR,
  FETCH_CHECKOUT_DELIVERY_WINDOWS_SUCCESS,
  REQUEST_CHECKOUT_DELIVERY_WINDOWS,
} from 'src/app/state/actions';
import type { Dispatch } from 'src/app/state/store';

export const getDeliveryWindows = (client, { cartIdentifier, deliveryAddressId }) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch({
        type: REQUEST_CHECKOUT_DELIVERY_WINDOWS,
      });
      const response = await client.bffGetCartDeliveryWindows(cartIdentifier, deliveryAddressId);
      const data = response?.data;
      dispatch({
        type: FETCH_CHECKOUT_DELIVERY_WINDOWS_SUCCESS,
        data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_CHECKOUT_DELIVERY_WINDOWS_ERROR,
        error,
      });
      Sentry.captureException(error);
    }
  };
};
